import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import QuestionBank from "../../components/AcademicQuestionBank";
import TechnoAEP from "../../components/AcademicTechnoAEP";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const sectionWrapper = (bg, color = "#000") => ({
  padding: "80px 20px",
  background: bg,
  color: color,
});

const containerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
};

const AcademicsPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [preprimary, setPreprimary] = useState(null);
  const [primary, setPrimary] = useState(null);
  const [senior, setSenior] = useState({
    section: null,
    blocks: []
  });

  const [secondary, setSecondary] = useState(null);
  const [card, setStreams] = useState([]);
  const [card_grid_1_content, setCardGridContent1] = useState([]);
  const [card_grid_1_block, setCardGridBlock1] = useState([]);
  const [card_grid_2_content, setCardGridContent2] = useState([]);
  const [card_grid_2_block, setCardGridBlock2] = useState([]);
  const [card_grid_3_content, setCardGridContent3] = useState([]);
  const [card_grid_3_block, setCardGridBlock3] = useState([]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  /* ---------------- FETCH PRE-PRIMARY ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";
    setLoading(true);
    axios
      .get(
        `${baseAPIUrl}api/academic/pre_primary/${finalSchoolSlug}`
      )
      .then(res => {
        if (res.data.status === 1) setPreprimary(res.data.data);
        else setPreprimary(null);
      })
      .catch(() => setPreprimary(null))
      .finally(() => setLoading(false));
  }, [school_slug]);

  /* ---------------- FETCH PRIMARY ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(
        `${baseAPIUrl}api/academic/primary/${finalSchoolSlug}`
      )
      .then(res => {
        if (res.data.status === 1) setPrimary(res.data.data);
        else setPrimary(null);
      })
      .catch(() => setPrimary(null));
  }, [school_slug]);

  /* ---------------- FETCH SENIOR ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";
    axios
      .get(
        `${baseAPIUrl}api/academic/senior/${finalSchoolSlug}`
      )
      .then(res => {
        console.log("SENIOR API RESPONSE:", res.data);
        if (res.data.status === 1) {
          setSenior(res.data.data);
        }
      })
      .catch(err => console.error(err));
  }, [school_slug]);

  /* ---------------- FETCH SENIOR SECONDARY---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";
    fetchSeniorSecondary();
  }, [school_slug]);

  const fetchSeniorSecondary = async () => {
    const finalSchoolSlug = school_slug || "tigps-main";
    setLoading(true);

    try {
      const res = await axios.get(
        `${baseAPIUrl}api/academic/senior_secondary/${finalSchoolSlug}`
      );

      if (res.data?.status === 1 && res.data?.data) {
        setSecondary(res.data.data.section || null);
        setCardGridContent1(res.data.data.card_grid_1_content || null);
        setCardGridBlock1(res.data.data.card_grid_1_block || []);
        setCardGridContent2(res.data.data.card_grid_2_content || null);
        setCardGridBlock2(res.data.data.card_grid_2_block || []);
        setCardGridContent3(res.data.data.card_grid_3_content || null);
        setCardGridBlock3(res.data.data.card_grid_3_block || []);
      } else {
        resetSeniorSecondary();
      }
    } catch (err) {
      console.error("Senior Secondary API Error:", err);
      resetSeniorSecondary();
    } finally {
      setLoading(false);
    }
  };

  const resetSeniorSecondary = () => {
    setSecondary(null);
    setCardGridContent1(null);
    setCardGridBlock1([]);
    setCardGridContent2(null);
    setCardGridBlock2([]);
    setCardGridContent3(null);
    setCardGridBlock3([]);
  };



  return (
    <div className="academics-page">
      <SchoolInnerPageBanner />

      {/* Pre-Primary Program Section */}
      {!loading && preprimary?.section && (
        <section id="pre-primary-program" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

            <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>
              {preprimary.section.heading}
            </h2>

            <p style={{ lineHeight: '1.8', marginBottom: '30px', }}>{preprimary.section.introduction_text}</p>

            {preprimary.blocks.map((block, idx) => (
              <div key={idx} style={{ marginBottom: "30px" }}>

                {block.heading && <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontFamily: 'Lora' }}>{block.heading}</h3>}

                {/* BULLET LIST */}
                {block.block_type === "bullet_list" && (
                  <ul style={{ fontSize: '1.1rem', lineHeight: '1.7', marginBottom: '30px', paddingLeft: '20px' }}>
                    {block.items.map((item, i) => (
                      <li style={{ marginBottom: '10px' }} key={i}>{item}</li>
                    ))}
                  </ul>
                )}

                {/* CARD GRID */}
                {block.block_type === "card_grid" && (

                  <div className="row" >
                    {block.items.map((card, i) => (
                      <div key={i} className="col-md-3 mb-3" >

                        <div className="card p-3 text-center" style={{ background: 'rgba(255,255,255,0.1)', padding: '20px', borderRadius: '10px', textAlign: 'center', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: "#fff", fontFamily: "Metropolis-Regular", fontSize: '1rem', }}>{card}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* PARAGRAPH */}
                {block.block_type === "paragraph" && (
                  <p>{block.content}</p>
                )}

              </div>
            ))}

            <p style={{ fontWeight: '500', textAlign: 'center', background: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '10px' }}>{preprimary.section.highlight_text}</p>

            {preprimary.section.section_image && (
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                <img
                  src={preprimary.section.section_image}
                  alt={preprimary.section.heading}
                  style={{ maxWidth: '500px', width: '100%', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.2)' }}
                />
              </div>
            )}

          </div>
        </section>
      )}

      {/* Primary Program Section */}
      {!loading && primary?.section && (
        <section id="primary-program" style={{ padding: '80px 20px', background: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

            {/* SECTION HEADING */}
            <h2 style={{ fontSize: '2.5rem', fontWeight: '600', color: 'rgb(100, 19, 32)', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>
              {primary.section.heading}
            </h2>

            {/* INTRO */}
            <p style={{ color: '#333', marginBottom: '30px' }}>
              {primary.section.introduction_text}
            </p>

            {/* BLOCKS */}
            {primary.blocks.map((block, idx) => {
              let content = {};

              try {
                content = typeof block.content === "string"
                  ? JSON.parse(block.content)
                  : block.content;
              } catch {
                content = {};
              }

              /* ---------- CARD GRID (SUBJECTS + FEATURES) ---------- */
              if (block.block_type === "card_grid") {
                return (
                  <div key={idx}>

                    <h3 style={{
                      fontSize: "1.4rem",
                      color: "rgb(100,19,32)",
                      marginBottom: "20px",
                    }}>
                      {block.heading}
                    </h3>

                    {/* INTRO 1 */}
                    <p style={{ marginBottom: "20px" }}>
                      {content.intro_1}
                    </p>

                    {/* SUBJECT CARDS */}
                    <div className="row mb-4">
                      {content.items_1?.map((item, i) => (
                        <div key={i} className="col-md-6 col-lg-3 mb-3">
                          <div style={{
                            background: "#f8f9fa",
                            border: "2px solid rgb(100,19,32)",
                            borderRadius: "10px",
                            height: "80px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "rgb(100,19,32)",
                            fontSize: "1.1rem"
                          }}>
                            {item}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* INTRO 2 */}
                    <p style={{ marginBottom: "20px" }}>
                      {content.intro_2}
                    </p>

                    {/* FEATURE CARDS */}
                    <div className="row mb-4">
                      {content.items_2?.map((card, i) => (
                        <div key={i} className="col-md-4 mb-3">
                          <div style={{
                            background: "#f8f9fa",
                            border: "2px solid rgb(100,19,32)",
                            borderRadius: "10px",
                            padding: "20px",
                            flex: '1',
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: "center"
                          }}>
                            <h4 style={{
                              color: "rgb(100,19,32)",
                              marginBottom: "10px",
                              fontSize: "1.2rem",
                              fontFamily: "Lora"
                            }}>
                              {card.heading}
                            </h4>
                            <p className="feature-cards-p">
                              {card.content}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                );
              }

              /* ---------- SIMPLE CARD GRID ---------- */
              if (block.block_type === "card_grid_simple") {
                return (
                  <div key={idx}>
                    <h3 style={{
                      fontSize: "1.5rem",
                      color: "rgb(100,19,32)",
                      marginBottom: "20px",
                      fontFamily: "Lora"
                    }}>
                      {block.heading}
                    </h3>

                    <p style={{ marginBottom: "20px" }}>
                      {content.intro}
                    </p>

                    <div className="row">
                      {content.items?.map((item, i) => (
                        <div key={i} className="col-md-6 col-lg-3 mb-3">
                          <div style={{
                            background: "rgb(100,19,32)",
                            color: "white",
                            height: "80px",
                            borderRadius: "10px",
                            flex: '1',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: '1rem',
                            fontFamily: "Metropolis-Regular"
                          }}>
                            {item}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              }

              return null;
            })}

            {/* IMAGE */}
            {primary.section.section_image && (
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                <img
                  src={primary.section.section_image}
                  alt={primary.section.heading}
                  style={{
                    maxWidth: "500px",
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
                  }}
                />
              </div>
            )}

          </div>
        </section>
      )}

      {/* Senior Section */}
      {senior?.section && (
        <section id="senior-section" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

            <h2 className="text-center mb-5" style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>
              {senior.section.heading}
            </h2>

            <p className="mb-4" style={{ lineHeight: '1.8', marginBottom: '30px' }}>
              {senior.section.introduction_text}
            </p>

            {(senior.blocks || []).map((block, idx) => (
              <div key={idx} className="mb-5">
                <h3 className="text-center mb-4" style={{ fontSize: '1.5rem', marginBottom: '30px', fontFamily: 'Lora', textAlign: 'center' }}>{block.heading}</h3>

                <div className="row" style={{ marginBottom: '50px' }}>
                  {(block.items || []).map((item, i) => (
                    <div key={i} className="col-6 col-md-3 mb-3">
                      <div className="academic-card" style={{ background: 'rgba(255,255,255,0.1)', padding: '15px', borderRadius: '10px', textAlign: 'center', height: '70px', flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', marginBottom: '0', fontFamily: 'Metropolis-Regular' }}>{item}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="academic-highlight" style={{ fontSize: '1.1rem', lineHeight: '1.8', fontFamily: 'Metropolis-Regular', textAlign: 'center', background: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '10px' }}>
              {senior.section.highlight_text}
            </div>

            {senior.section.section_image && (
              <div className="text-center mt-5">
                <img
                  src={senior.section.section_image}
                  alt="Senior"
                  style={{ maxWidth: "500px", width: "100%" }}
                />
              </div>
            )}
          </div>
        </section>
      )}

      {/* Senior Secondary Program Section */}
      {secondary && (
        <section id="senior-secondary-program" className="senior-secondary-section">
          <div className="senior-secondary-container">

            {/* Title */}
            <h2 className="senior-secondary-title">
              {secondary.heading}
            </h2>

            {/* Introduction */}
            {(secondary.introduction_text) && (
              <p className="primary-text">
                {secondary.introduction_text}
              </p>
            )}

            {/* card_grid_1 */}
            {card_grid_1_block?.length > 0 && (
              <>
                <h3 className="section-heading">
                  {card_grid_1_content.card_heading}
                </h3>
                <p style={{ lineHeight: '1.7', color: '#333', marginBottom: '25px' }}>
                  {card_grid_1_content.card_intro}
                </p>

                <div className="row mb-5">
                  {card_grid_1_block.map((stream, index) => (
                    <div key={index} className="col-md-4 mb-4">
                      <div className="stream-card">
                        <h4>{stream.heading}</h4>
                        <p>{stream.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* card_grid_2 */}
            {card_grid_2_block?.length > 0 && (
              <>
                <h3 className="section-heading">
                  {card_grid_2_content.card_heading}
                </h3>
                <p style={{ lineHeight: '1.7', color: '#333', marginBottom: '25px' }}>
                  {card_grid_2_content.card_intro}
                </p>
                <div className="row mb-5">
                  {card_grid_2_block.map((item, index) => (
                    <div key={index} className="col-md-6 col-lg-3 mb-3">
                      <div className="support-card">
                        <h4>{typeof item === "string" ? item : item.content}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* card_grid_3 */}
            {card_grid_3_block?.length > 0 && (
              <>
                <h3 className="section-heading">
                  {card_grid_3_content.card_heading}
                </h3>
                <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', marginBottom: '25px', fontFamily: 'Lora' }}>
                  {card_grid_3_content.card_intro}
                </p>
                <div className="row">
                  {card_grid_3_block.map((item, index) => (
                    <div key={index} className="col-md-6 col-lg-3 mb-3">
                      <div className="holistic-card">
                        <h4>{item.heading}</h4>
                        <p>{item.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* IMAGE */}
            {secondary.image && (
              <div className="secondary-image-wrapper">
                <img
                  src={secondary.image}
                  alt="Senior Secondary Education"
                />
              </div>
            )}

          </div>
        </section>
      )}

      {/* Question Bank Section */}
      <QuestionBank />

      {/* Techno AEP Section */}
      <TechnoAEP />
    </div>
  );

};

export default AcademicsPage;